/* CLTR product page extras 2 (snippets/cltr-pdp-plus.liquid): share buttons and the zoom hint. */
(function () {
  'use strict';

  /* Copy link and the phone's own share sheet */
  document.addEventListener('click', function (e) {
    var copy = e.target.closest && e.target.closest('[data-cltrx-copy]');
    if (copy) {
      var url = copy.getAttribute('data-url');
      var label = copy.querySelector('[data-cltrx-copy-label]');
      var done = function () {
        copy.classList.add('is-done');
        if (label) label.textContent = 'Link copied';
        setTimeout(function () { copy.classList.remove('is-done'); if (label) label.textContent = 'Copy link'; }, 2000);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(done, function () { window.prompt('Copy this link', url); });
      } else {
        window.prompt('Copy this link', url);
      }
      return;
    }
    var nat = e.target.closest && e.target.closest('[data-cltrx-native]');
    if (nat && navigator.share) {
      navigator.share({ title: nat.getAttribute('data-title'), url: nat.getAttribute('data-url') }).catch(function () {});
    }
  });

  function showNative() {
    if (!navigator.share) return;
    document.querySelectorAll('[data-cltrx-native]').forEach(function (b) { b.hidden = false; });
  }

  /* "Tap to zoom" on the gallery. The gallery is swapped out when the colour changes, so watch for it. */
  var ICON = '<svg viewBox="0 0 16 16" aria-hidden="true"><circle cx="7" cy="7" r="4.5" fill="none" stroke="currentColor" stroke-width="1.4"/><path d="M10.5 10.5L14 14M7 5v4M5 7h4" stroke="currentColor" stroke-width="1.4"/></svg>';
  function zoomHint() {
    var g = document.querySelector('media-gallery');
    if (!g || !g.querySelector('.product-media-container--zoomable') || g.querySelector('.cltrx-zoomhint')) return;
    var host = g.querySelector('slideshow-container') || g;
    if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
    var s = document.createElement('span');
    s.className = 'cltrx-zoomhint';
    s.setAttribute('aria-hidden', 'true');
    var touch = window.matchMedia('(hover: none)').matches;
    s.innerHTML = ICON + (touch ? 'Tap to zoom' : 'Click to zoom');
    host.appendChild(s);
  }

  /* The CLTR gallery HUD (cltr-pdp.js) is only built once, so rebuild it when the gallery is swapped. */
  function pad(n) { return n < 10 ? '0' + n : '' + n; }
  function hud() {
    var g = document.querySelector('media-gallery');
    if (!g || g.querySelector('.cltr-gal-hud')) return;
    var codeEl = document.querySelector('[data-cltr-code]');
    var el = document.createElement('div');
    el.className = 'cltr-gal-hud';
    el.setAttribute('aria-hidden', 'true');
    el.innerHTML = '<i class="tl"></i><i class="tr"></i><i class="bl"></i><i class="br"></i>' +
      '<span class="cltr-gal-hud__code">' + (codeEl ? codeEl.getAttribute('data-cltr-code') : '') + '</span>' +
      '<span class="cltr-gal-hud__count"><b>01</b> / <span>01</span></span>';
    var host = g.querySelector('slideshow-container') || g;
    host.style.position = host.style.position || 'relative';
    host.appendChild(el);
    var b = el.querySelector('.cltr-gal-hud__count b');
    var t = el.querySelector('.cltr-gal-hud__count span');
    function update() {
      var slides = g.querySelectorAll('slideshow-slide');
      var cur = 0;
      for (var i = 0; i < slides.length; i++) if (slides[i].getAttribute('aria-hidden') === 'false') { cur = i; break; }
      b.textContent = pad(cur + 1);
      t.textContent = pad(slides.length || 1);
      el.classList.toggle('is-single', slides.length < 2);
    }
    update();
    new MutationObserver(update).observe(g, { attributes: true, subtree: true, attributeFilter: ['aria-hidden'] });
  }

  function refresh() { hud(); zoomHint(); }

  function init() {
    showNative();
    zoomHint();
    var main = document.querySelector('media-gallery');
    var scope = main && main.closest('.shopify-section');
    if (scope) new MutationObserver(refresh).observe(scope, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
